<template>
    <div class="terms__content">
        <h1 class="terms__title">Términos y condiciones.</h1>
        <div class="terms__text">
            <p>
            Bienvenido al Sitio Web <b>“Enamórate del Cesar” de la Universidad Popular del 
            Cesar (UNICESAR)</b>.   Al acceder y hacer uso de este sitio, aceptas y te 
            comprometes a cumplir con los términos y condiciones establecidos en este 
            documento:  
            <br><br>
            <b>1. Aceptación de Términos y Condiciones:</b>  Serás responsable por cualquier uso 
            indebido, ilegal o anormal que hagas del Sitio y su contenido. Se te prohíbe: 
            <ul>
            <li>Descargar imágenes, textos u otros contenidos del Sitio a menos que se indique 
            expresamente lo contrario.</li> 
            <li>Utilizar contenidos (imágenes, textos, videos) para fines publicitarios sin 
            autorización previa.</li> 
            <li>Realizar actividades técnicas que afecten el uso y la publicación de contenidos por 
            parte de los administradores autorizados de la <b>UNICESAR</b>.</li> 
            <li>Alterar el uso de marcas, logotipos y otros signos distintivos de la <b>UNICESAR</b>.</li> 
            </ul>
            La Universidad Popular del Cesar (<b>UNICESAR</b>) se reserva el derecho de tomar 
            acciones administrativas y legales contra cualquier usuario que haga un uso 
            indebido del Sitio y sus contenidos, lo que implica la responsabilidad de indemnizar 
            cualquier daño causado a la <b>UNICESAR</b> o a terceros. 
            <br><br>
            <b>2. Responsabilidad por la Información:</b> Comprendes y aceptas que la 
            <b>UNICESAR</b> no se hace responsable por los comentarios y opiniones publicados por 
            los usuarios en los espacios abiertos del Sitio.  Aunque la <b>UNICESAR</b> realiza 
            esfuerzos técnicos para mantener el sitio libre de virus y software malicioso, no 
            garantiza la ausencia de elementos que puedan dañar tu sistema informático. 
            <br><br>
            <b>3. Enlaces a Sitios Web de Terceros:</b> El Sitio puede contener enlaces a otros sitios 
            web. Estos enlaces se proporcionan con el propósito de ampliar los contenidos. Sin 
            embargo, la <b>UNICESAR</b> no asume responsabilidad por el contenido, funcionamiento 
            o privacidad de dichos sitios. Al hacer clic en enlaces y salir del Sitio, lo haces bajo 
            tu propio riesgo. 
            <br><br>
            <b>4. Propiedad Intelectual y Derechos Reservados:</b> El diseño del Sitio, su 
            contenido, bases de datos, interfaces, herramientas y más están protegidos por 
            leyes de propiedad intelectual. Queda prohibida su utilización, reproducción, 
            distribución, transformación, entre otros, sin autorización previa y por escrito de la 
            <b>UNICESAR</b>. Las marcas y signos distintivos relacionados con la <b>UNICESAR</b> son 
            propiedad de la Universidad y su uso requiere autorización. 
            <br><br>
            <b>5. Ley Aplicable y Resolución de Controversias:</b> Cualquier conflicto relacionado 
            con estos términos se resolverá de acuerdo a las leyes de Colombia. Se buscará 
            primero un acuerdo directo entre las partes, y en caso necesario, se seguirán los 
            procedimientos legales de Colombia. 
            <br><br>
            <b>6. Actualización de Términos y Condiciones:</b> Estos términos aplican a todos los 
            usuarios del Sitio. La <b>UNICESAR</b> se reserva el derecho de modificarlos en cualquier 
            momento sin previo aviso. Las modificaciones entrarán en vigor al ser publicadas 
            en el Sitio.
            </p>

        </div>
    </div>
</template>

<script>
export default {
    name: "edc-about-view"
}
</script>

<style>
.terms__content {
    width: 100%;
    max-width: 1000px;
    padding: 0px 24px;
    margin: 40px auto;
}

.terms__text {
    text-align: justify;
}

.terms__title {
    width: 100%;
    line-height: 110%;
    margin-bottom: 16px;
}
</style>

